import type { VerticalConfig } from '../interfaces/vertical-config.interface';

/**
 * Injection point for `VerticalLabelPipe`. Kept dependency-free (no
 * SignalContextService) so it's safe for looky/core to import — the real
 * SignalContextService-backed implementation is provided from
 * `@callrail/looky/common/core/api` and bound to this token in each app's
 * root providers. If nothing is bound, `VerticalLabelPipe` falls back to its
 * default label — see `@callrail/looky/common/core/api`'s
 * `SignalContextVerticalConfigResolver`.
 */
export abstract class VerticalConfigResolver {
  abstract resolve(): VerticalConfig | undefined;
}
